// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { OrderedListItemFragmentDoc } from './orderedListItem.generated';
export const ComponentOrderedListFragmentDoc = `
    fragment componentOrderedList on ComponentOrderedList {
  __typename
  items {
    ...orderedListItem
  }
}
    `;